import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Modal from 'react-modal';
import LandingPage from './pages/LandingPage';
import FingeringPage from './pages/fingering/FingeringPage';
import FingeringEditorPage from './pages/fingering/FingeringEditorPage';
import HelpPage from './pages/help/HelpPage';
// PoC 実機確認用・#10 統合後に削除 — issue #60 サムネイル選択 iPhone GO/NOGO ゲート
import PocPageRangePage from './pages/poc/PocPageRangePage';
import { useHealthCheck } from './hooks/useHealthCheck';
import { HealthStatusContext } from './contexts/HealthStatusContext';
import { ToastProvider } from './components/ToastProvider';
import { JobTrackerProvider } from './contexts/JobTrackerContext';
import { DriveAuthProvider } from './contexts/DriveAuthContext';

function App() {
  // App mount 時 + visibilitychange (visible) で backend / score-engine の health を観測。
  // 旧 useScoreEngineWarmup の silent ping (予熱目的、 issue #15) は本 hook の trigger
  // (mount + visibilitychange + 60s throttle) が機能的に肩代わりする (issue #53 で統合)。
  const healthStatus = useHealthCheck();
  useEffect(() => {
    // Set app element for react-modal (accessibility)
    Modal.setAppElement('#root');
  }, []);
  return (
    <HealthStatusContext.Provider value={healthStatus}>
      <ToastProvider>
        <DriveAuthProvider>
          <JobTrackerProvider>
            <Router>
              <div className="min-h-screen bg-gradient-to-br from-gray-100 to-gray-200 p-5">
                <Routes>
                  <Route path="/" element={<LandingPage />} />
                  <Route path="/fingering" element={<FingeringPage />} />
                  <Route path="/fingering/editor" element={<FingeringEditorPage />} />
                  <Route path="/fingering/jobs" element={<Navigate to="/fingering" replace />} />
                  <Route path="/help" element={<HelpPage />} />
                  {/* PoC 実機確認用・#10 統合後に削除 — issue #60 サムネイル選択 iPhone GO/NOGO ゲート */}
                  <Route path="/poc-pagerange" element={<PocPageRangePage />} />
                </Routes>
              </div>
            </Router>
          </JobTrackerProvider>
        </DriveAuthProvider>
      </ToastProvider>
    </HealthStatusContext.Provider>
  );
}

export default App;
